import { MuteLabel } from '@elements/FormField';
import { RadioArrayContainer } from '../styles/common';
import { Field } from '../Desktop/Field';

export function RadioArray({
  actionAllowed,
  actionButtonClick,
  errors,
  fields,
  item,
  label,
  name,
  onChange,
  readOnly,
  values,
}) {
  const onItemChange = value => {
    onChange(name, value);
    if (item.triggerApi) {
      actionButtonClick &&
        actionButtonClick({
          ...item,
          triggerDynamicApi: true,
          extraParams: {
            [item.name]: value,
          },
        });
    }
  };

  return (
    <div className="sk:px-3.5! sk:mt-3.5!">
      <MuteLabel>{label}</MuteLabel>
      <RadioArrayContainer>
        {fields.map((row, index) => (
          <div>
            <Field
              key={row.name}
              value={values}
              error={errors ? errors[row.name] : null}
              item={row}
              onChange={value => onItemChange(value)}
              index={index}
              style
              // @ts-expect-error - TS2322: Type '{ key: any; value: any; error: any; item: any; onChange: (value: any) => v...
              actionAllowed={actionAllowed}
              readOnly={readOnly}
            />
          </div>
        ))}
      </RadioArrayContainer>
    </div>
  );
}
